export default __webpack_public_path__ + "static/media/notify.8ec3c059.svg";